import React from 'react';
import _ from 'lodash';
import appStyles from 'Routes/Routes.css';
import RouteLoading from 'Components/RouteLoading';
import errorController from 'Components/ErrorScreens';
import useGetReduxUsers from 'Hooks/reduxHelperHooks/useGetReduxUsers';
import useAlertBanner from 'Hooks/reduxHelperHooks/useAlertBanner';
import { configService } from 'Services';
import { useTranslation } from 'react-i18next';
import useGetSingleListAndSetBreadcrumb from '../hooks/useGetSingleListAndSetBreadcrumb';
import Header from './components/Header';
import SingleListOverview from '../../components/SingleListOverview';
import ListEntryTable from '../../components/ListEntryTable';

const ListRoute = () => {
    const { t } = useTranslation();
    const { users } = useGetReduxUsers();
    const { addAlert } = useAlertBanner();
    const { query: singleListAPI, listId } = useGetSingleListAndSetBreadcrumb(users);
    const [isMissingConfigCustomList, setMissingConfigCustomList] = React.useState(false);
    const { customListType } = singleListAPI.data ?? {};
    const { listType: customList } = customListType ?? {};
    const configCustomList = configService.customListTypes;
    const onMissingConfigListTypeError = () => {
        addAlert({
            id: 'missing-config-custom-list',
            content: t('MissingListTypeInConfig'),
            status: 'danger'
        });
        setMissingConfigCustomList(true);
    };
    React.useEffect(() => {
        if (customList && configCustomList) {
            const isListTypeInConfig = configCustomList?.some(
                (item: ConfigCustomListObj) => item.customListType === customList
            );
            if (!isListTypeInConfig) onMissingConfigListTypeError();
        }
    }, [customList, configCustomList]);
    const { hasError, errorCmp } = errorController([singleListAPI.error]);

    if (singleListAPI.isLoading) {
        return <RouteLoading />;
    }

    if (hasError || !singleListAPI.data || _.isEmpty(singleListAPI.data)) return errorCmp;

    return (
        <div className={appStyles.landingPage}>
            <Header
                title={singleListAPI.data!.name}
                listType={singleListAPI.data!.listType as SingleListType}
                listId={listId}
                merchantSpecific={singleListAPI.data!.merchantSpecific}
                customListType={customList}
                isMissingConfigCustomList={isMissingConfigCustomList}
            />
            <SingleListOverview data={singleListAPI.data as ListManagementApiList} />
            <ListEntryTable
                listType={singleListAPI.data.listType as SingleListType}
                listId={listId}
                listName={singleListAPI.data.name}
                customListType={customList}
                merchantSpecific={singleListAPI.data.merchantSpecific}
                users={users}
            />
        </div>
    );
};

export default ListRoute;
